import React from 'react';
import { Link } from 'react-router-dom';
import { FiTool, FiHeart } from 'react-icons/fi';
import { CATEGORIES, TOOLS } from '../../data/registry';

export const Footer = () => {
  return (
    <footer className="bg-slate-50 dark:bg-slate-950 border-t border-slate-200 dark:border-slate-800 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        
        {/* Brand Header Row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <div className="bg-primary-600 text-white p-1.5 rounded-lg">
                <FiTool className="w-4 h-4" />
              </div>
              <span className="font-bold text-lg tracking-tight text-slate-900 dark:text-white">
                FreeToolSuite<span className="text-primary-600 dark:text-primary-500">Pro</span>
              </span>
            </Link>
            <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed max-w-sm">
              Your comprehensive suite of 100% free, client-side browser tools. No server uploads, total privacy, incredibly fast processing.
            </p>
          </div>
          <div className="flex gap-4">
            <Link to="/about" className="text-sm font-medium text-slate-600 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400">About Us</Link>
            <Link to="/contact" className="text-sm font-medium text-slate-600 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400">Contact</Link>
          </div>
        </div>

        {/* Categories & 100% Tools Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8 border-t border-slate-200 dark:border-slate-800 pt-12">
          {CATEGORIES.map(category => {
            const categoryTools = TOOLS.filter(t => t.category === category);
            return (
              <div key={category}>
                <h3 className="text-sm font-bold text-slate-900 dark:text-white tracking-wider mb-4 uppercase">
                  {category}
                </h3>
                <ul className="space-y-2.5">
                  {categoryTools.map(tool => (
                    <li key={tool.slug}>
                      <Link to={`/tools/${tool.slug}`} className="text-sm text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors block truncate pr-2" title={tool.name}>
                        {tool.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200 dark:border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500 dark:text-slate-400 flex items-center gap-1">
            &copy; {new Date().getFullYear()} FreeToolSuitePro. Made with <FiHeart className="text-red-500" /> for developers.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-sm text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};